// used for various case colors e.g. bars
export const CASES_LIGHT_BLUE = '#94C1CF';

// used as the case average line
export const CASES_DARK_BLUE = '#0082AA';

// used as the error offset color for cases
export const CASES_LIGHT_GREY = '#E0DCDB';

// used for various death colors e.g. bars
export const DEATHS_LIGHT_GREY = '#829DB0';

// used as the death average line
export const DEATHS_DARK_GREY = '#6D8292';
export const DEATHS_DARKEST_GREY = '#46525f';

// used for vaccines
export const VACCINES_GREEN = '#65772c';
export const VACCINES_GREEN_LIGHT = '#c2d48a';
export const VACCINES_GREEN_MEDIUM = '#c4d876';

export const SCHOOLS_LIGHT_BLUE = '#83c6e0';
export const SCHOOLS_DARK_BLUE = '#1281aa';
export const SCHOOLS_LIGHT_GREY = '#999999';
export const SCHOOLS_ORANGE = '#d36627';

// used for schools
export const SCHOOLS_HIGH = '#8da0cb';
export const SCHOOLS_MIDDLE = '#fc8d62';
export const SCHOOLS_ELEM = '#66c2a5';
